<template>
  <div class="sp-template">
    <div class="h-title">订单费用</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="110px">
          <el-row>
            <el-form-item label="类型">
              <el-select v-model="queryForm.timeType" clearable>
                <el-option v-for="(d, i) in timeTypes" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户">
              <el-select v-model="queryForm.customerIds" filterable clearable multiple placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号/批次号">
              <el-input type="textarea" v-model="orderIds" placeholder="多个单号用回车分割"></el-input>
            </el-form-item>
            <el-form-item label="供应商">
              <el-select v-model="queryForm.supplierId" filterable clearable>
                <el-option v-for="item in suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
           <el-collapse-transition>
						<div v-show="isSearchMore">
              <el-row>
                <el-form-item label="渠道">
                  <el-select v-model="queryForm.productIds" filterable clearable multiple placeholder="选择渠道">
                    <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="收款状态">
                  <el-select v-model="queryForm.settlementStatus" multiple clearable placeholder="选择收款状态">
                    <el-option v-for="(d, i) in settlementStatus" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="付款状态">
                  <el-select v-model="queryForm.paymentStatus" multiple clearable placeholder="选择付款状态">
                    <el-option v-for="(d, i) in paymentStatus" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="仓库">
                  <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                    <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
            <!-- <el-form-item label="客户类型">
              <el-select v-model.lazy="queryForm.customerType" clearable>
                <el-option v-for="(d, i) in customerTypeList" :key="i" :label="d.name" :value="d.value"></el-option>
              </el-select>
            </el-form-item> -->
                <el-form-item label="开始日期">
                  <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
                </el-form-item>
              </el-row>
						</div>
          </el-collapse-transition>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(41002)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button v-if="in_configs(41002)" size="small" @click="reset()">清 空</el-button>
            <a class="toggle-icon" @click.stop.prevent="isSearchMore = !isSearchMore">
							<b v-show="isSearchMore">隐藏</b><b v-show="!isSearchMore">展开</b>更多搜索条件
            </a>
          </div>
        </el-form>
      </div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(41003)" size="small" @click="exportOrderCost">导出订单费用</el-button>
          <el-button v-if="in_configs(41004)" size="small" @click="downloadBill">导出运费对账单</el-button>
          <el-button v-if="in_configs(41009)" size="small" @click="costImport">订单成本差价补录</el-button>
        </div>
      </div>
      <!-- <vue-scroll :ops="ops"> -->
      <el-table :data="tableData" stripe border style="width: 100%;" max-height="800" ref="table">
        <el-table-column prop="orderId" label="订单号" width="150"></el-table-column>
        <el-table-column label="仓库">
          <template slot-scope="scope">
            {{warehouseMap[scope.row.warehouseId]}}
          </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.product]}}
          </template>
        </el-table-column>
        <el-table-column label="客户单号" width="200">
          <template slot-scope="scope">
            <span v-html="judge(scope.row.customerNumber)"></span>
            <!-- {{judge(scope.row.customerNumber)}} -->
          </template>
        </el-table-column>
        <el-table-column label="实重/计费重" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.actuallyWeight !== null">
              <span class="name-tooltips first">实</span>{{scope.row.actuallyWeight.toFixed(3)}}</div>
            <div v-if="scope.row.chargingWeight !== null">
              <span class="name-tooltips second">计</span>{{scope.row.chargingWeight.toFixed(3)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="利润/成本" width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.estimateCostCharge!= null && scope.row.estimateCostCharge!='' && in_configs(41006)">
              <span class="name-tooltips second">成本</span>{{scope.row.estimateCostCharge!= null && scope.row.estimateCostCharge!="" ? scope.row.estimateCostCharge : 0}}
              <!-- <a href="#" title="点击查看明细" @click="showAllBasicVariables(scope.row.trace)">
                <i class="el-icon-zoom-in"></i>
              </a> -->
            </div>
            <div v-if="scope.row.estimateCostCharge!= null && scope.row.estimateCostCharge!='' && in_configs(41008)">
              <span class="name-tooltips first">利润</span>{{scope.row.estimateCostCharge!= null && scope.row.estimateCostCharge!="" ? (scope.row.totalAmount - scope.row.estimateCostCharge).toFixed(2) : scope.row.totalAmount.toFixed(2)}}
            </div> 
            <div v-if="scope.row.costCharge!= null && scope.row.costCharge!='' && in_configs(41007)">
              <span class="name-tooltips second">财务成本</span>{{scope.row.costCharge!= null && scope.row.costCharge!="" ? scope.row.costCharge.toFixed(2) : 0}}
              <span class="name-tooltips second" style="background:red"
                v-if="(scope.row.costCharge > scope.row.totalAmount) || ((scope.row.totalAmount - scope.row.costCharge).toFixed(2) > (scope.row.totalAmount*0.5))">异常</span>
            </div>
            <div v-if="scope.row.costCharge!= null && scope.row.costCharge!='' && in_configs(41005)">
              <span class="name-tooltips first">财务利润</span>{{scope.row.costCharge!= null && scope.row.costCharge!="" ? (scope.row.totalAmount - scope.row.costCharge).toFixed(2) : scope.row.totalAmount.toFixed(2)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="总费用"></el-table-column>
        <el-table-column label="价格类型">
          <template slot-scope="scope">
            <div class="trace-item" :style="'height:'+ (scope.row.items.length*34) +'px;line-height:'+ (scope.row.items.length*34) +'px;'">销售</div>
            <div v-if="in_configs(41007)" class="trace-item" :style="'height:'+ (scope.row.costItems.length*34) +'px;line-height:'+ (scope.row.costItems.length*34) +'px;'">财务成本</div>
            <div v-if="in_configs(41006)" class="trace-item" :style="'height:'+ (scope.row.estimateCostItems.length*34) +'px;line-height:'+ (scope.row.estimateCostItems.length*34) +'px;'">预估成本</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <div class="trace-item" :style="'height:'+ (scope.row.items.length*34) +'px;line-height:'+ (scope.row.items.length*34) +'px;'">
              {{scope.row.settlementStatus == 'no_settlement' ? "未收款": (scope.row.settlementStatus == 'partial_settlement' ? "部分收款" : "已收款")}}
            </div>
            <div v-if="in_configs(41007)" class="trace-item" :style="'height:'+ (scope.row.costItems.length*34) +'px;line-height:'+ (scope.row.costItems.length*34) +'px;'">
              {{scope.row.paymentStatus == 'no_settlement' ? "未付款": (scope.row.paymentStatus == 'partial_settlement' ? "部分付款" : "已付款")}}
            </div>
            <div v-if="in_configs(41006)" class="trace-item" :style="'height:'+ (scope.row.estimateCostItems.length*34) +'px;line-height:'+ (scope.row.estimateCostItems.length*34) +'px;'">
              {{scope.row.paymentStatus == 'no_settlement' ? "未付款": (scope.row.paymentStatus == 'partial_settlement' ? "部分付款" : "已付款")}}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="createAt" label="预报时间" width="160"></el-table-column> -->
        <el-table-column width="180" label="费用类型">
          <template slot-scope="scope">
            <div v-for="(d, i) in scope.row.items" :key="i+'a'" class="trace-item">{{d.serviceType}}</div>
            <span v-if="in_configs(41007)">
              <div v-for="(d, i) in scope.row.costItems" :key="i+'b'" class="trace-item">{{d.serviceType}}</div>
            </span>
            <span v-if="in_configs(41006)">
              <div v-for="(d, i) in scope.row.estimateCostItems" :key="i+'b'" class="trace-item">{{d.serviceType}}</div>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="180" label="供应商">
          <template slot-scope="scope">
            <div v-for="(d, i) in scope.row.items" :key="i+'a'" class="trace-item">{{supplierMap[d.supplierId]}}</div>
            <span v-if="in_configs(41007)">
              <div v-for="(d, i) in scope.row.costItems" :key="i+'b'" class="trace-item">{{supplierMap[d.supplierId]}}</div>
            </span>
            <span v-if="in_configs(41006)">
              <div v-for="(d, i) in scope.row.estimateCostItems" :key="i+'b'" class="trace-item">{{supplierMap[d.supplierId]}}</div>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="120" label="状态">
          <template slot-scope="scope">
            <div v-for="(d, i) in scope.row.items" :key="i+'e'" class="trace-item">
              <div v-if="d.amount != 0">
                {{d.settlementStatus}}
              </div>
            </div>
            <span v-if="in_configs(41007)">
              <div v-for="(d, i) in scope.row.costItems" :key="i+'f'" class="trace-item">
                <div v-if="d.amount != 0">
                  {{d.settlementStatus != 'has_settlement' ? "未付款": "已付款"}}
                </div>
              </div>
            </span>
            <span v-if="in_configs(41006)">
              <div v-for="(d, i) in scope.row.estimateCostItems" :key="i+'f'" class="trace-item">
                <div v-if="d.amount != 0">
                <!--  {{d.settlementStatus != 'has_settlement' ? "未付款": "已付款"}} -->
                </div>
              </div>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="120" label="金额">
          <template slot-scope="scope">
            <div v-for="(d, i) in scope.row.items" :key="i+'c'" class="trace-item">{{d.amount}}</div>
            <span v-if="in_configs(41007)">
              <div v-for="(d, i) in scope.row.costItems" :key="i+'d'" class="trace-item">{{d.amount}}</div>
            </span>
            <span v-if="in_configs(41006)">
              <div v-for="(d, i) in scope.row.estimateCostItems" :key="i+'d'" class="trace-item">{{d.amount}}</div>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="120" label="币种">
          <template slot-scope="scope">
            <div v-for="(d, i) in scope.row.items" :key="i+'e'" class="trace-item">{{d.currency}}</div>
            <span v-if="in_configs(41007)">
              <div v-for="(d, i) in scope.row.costItems" :key="i+'f'" class="trace-item">{{d.currency}}</div>
            </span>
            <span v-if="in_configs(41006)">
              <div v-for="(d, i) in scope.row.estimateCostItems" :key="i+'f'" class="trace-item">{{d.currency}}</div>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="200" label="交易时间">
          <template slot-scope="scope">
            <div v-for="(d, i) in scope.row.items" :key="i+'g'" class="trace-item">{{d.txDate}}</div>
            <span v-if="in_configs(41007)">
              <div v-for="(d, i) in scope.row.costItems" :key="i+'h'" class="trace-item">{{d.txDate}}</div>
            </span>
            <span v-if="in_configs(41006)">
              <div v-for="(d, i) in scope.row.estimateCostItems" :key="i+'h'" class="trace-item">{{d.txDate}}</div>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="120" label="明细">
          <template slot-scope="scope">
            <div v-for="(d, i) in scope.row.items" :key="i+'i'" class="trace-item">
              <a v-if="d.serviceType == 'mainCharge'" href="#" title="点击查看明细" @click.prevent="showAllBasicVariables(d.trace)">
                <i class="el-icon-zoom-in"></i>
              </a>
              {{d.serviceType == "mainCharge" ? d.trace : null}}
            </div>
            <span v-if="in_configs(41007)">
              <div v-for="(d, i) in scope.row.costItems" :key="i+'j'" class="trace-item">
                <a v-if="d.serviceType == 'costCharge'" href="#" title="点击查看明细" @click.prevent="showAllBasicVariables(d.trace)">
                  <i class="el-icon-zoom-in"></i>
                </a>
                {{d.serviceType == "costCharge" ? d.trace : null}}
              </div>
            </span>
            <span v-if="in_configs(41006)">
              <div v-for="(d, i) in scope.row.estimateCostItems" :key="i+'j'" class="trace-item">
                <a v-if="d.serviceType == 'costCharge'" href="#" title="点击查看明细" @click.prevent="showAllBasicVariables(d.trace)">
                  <i class="el-icon-zoom-in"></i>
                </a>
                {{d.serviceType == "costCharge" ? d.trace : null}}
              </div>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="120" label="备注" fixed="right">
          <template slot-scope="scope">
            <div v-for="(d, i) in scope.row.items" :key="i+'k'" class="trace-item">
              <el-tooltip v-if="d.remarks && d.remarks !== ''" effect="dark" placement="top">
                <div slot="content">
                  <div>{{d.remarks}}</div>
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
              <span>{{d.remarks}}</span>
            </div>
            <span v-if="in_configs(41007)">
              <div v-for="(d, i) in scope.row.costItems" :key="i+'l'" class="trace-item">
                <el-tooltip v-if="d.remarks && d.remarks !== ''" effect="dark" placement="top">
                  <div slot="content">
                    <div>{{d.remarks}}</div>
                  </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <span>{{d.remarks}}</span>
              </div>
            </span>
            <span v-if="in_configs(41006)">
              <div v-for="(d, i) in scope.row.estimateCostItems" :key="i+'l'" class="trace-item">
                <el-tooltip v-if="d.remarks && d.remarks !== ''" effect="dark" placement="top">
                  <div slot="content">
                    <div>{{d.remarks}}</div>
                  </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <span>{{d.remarks}}</span>
              </div>
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <i size="mini" class="el-icon-plus" @click="addOrderCharge( scope.row)"></i>
            </template>
          </el-table-column> -->
      </el-table>
      <!-- </vue-scroll> -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

      <el-dialog title="明细" :visible.sync="dialogShowVariables" append-to-body>
        <p v-if="formulaStr !== ''" v-html="formulaStr"></p>
      </el-dialog>
      <!-- 添加费用 -->
      <el-dialog title="添加费用" :visible.sync="chargeVisible">
        <el-form :model="addChargeForm" size="small" id="uploadForm">
          <el-form-item label="客户名称" label-width="120px">{{addChargeForm.customerName}}</el-form-item>
          <el-form-item label="订单号" label-width="120px">{{addChargeForm.orderId}}</el-form-item>
          <el-form-item label="费用类型" label-width="120px">
            <el-select v-model="addChargeForm.chargeType">
              <el-option v-for="(d, i) in chargeType" :key="i" :label="d.name" :value="d.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="币种" label-width="120px">
            <el-select name="currency" v-model="addChargeForm.currency">
              <el-option v-for="currency in currencies" :label="currency.name" :value="currency.value" :key="currency.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额" label-width="120px">
            <el-input type="number" min="0" v-model.lazy="addChargeForm.amount" placeholder="金额"></el-input>
          </el-form-item>

          <el-form-item label="备注" label-width="120px">
            <el-input type="textarea" v-model="addChargeForm.remarks"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="chargeVisible=false">取 消</el-button>
          <el-button type="primary" @click="addChargeDone">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="成本差额补录" :visible.sync="dialogVisible2" width="500px">
        <el-form size="small" style="border-bottom:1px solid #eee;" >
          <el-form-item label="上传文件" label-width="80px">
            <el-upload action="#" name="upload" :limit="1" list-type="text" accept=".xlsx,.xls" 
            :on-change="handlePictureCardChange" :on-remove="handleRemove" :auto-upload="false"
            :file-list="fileList" style="display: inline-block;">
              <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
            </el-upload>
            <a href="../../../static/template/order_cost_charge.xlsx" download="order_cost_charge.xlsx" style="margin-left:50px;display: inline-block; vertical-align: top;">
              <el-button size="small" type="text">下载模板</el-button>
            </a>
          </el-form-item>
        </el-form>
        <div slot="footer" >
          <el-button class="dialog-footer" size="small" type="primary" @click="dialogVisible2 = false" >取消</el-button>
          <el-button class="dialog-footer" size="small" type="primary" @click="costChargeImport(false)" >提交</el-button>
        </div>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="dialogVisible3" width="500px">
        <span>{{costImportMsg}}</span>
        <div slot="footer" >
          <el-button class="dialog-footer" size="small" type="primary" @click="continueUpload" >{{isCancel ? "取消" : "继续上传"}}</el-button>
          <el-button class="dialog-footer" size="small" type="primary" @click="download" >下载excel文件</el-button>
        </div>
      </el-dialog>
    </el-card>
    <form id="theform" target="_blank"></form>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'

export default {
  data() {
    return {
      ops: {
        rail: {
          vRail: {
            width: "6px",
            pos: "left",
            background: "#A9A9A9",
            opacity: 0
          },
          //
          hRail: {
            height: "6px",
            pos: "top",
            background: "#A9A9A9",
            opacity: 0
          }
        },
        bar: {
          showDelay: 500,
          vBar: {
            background: "#A9A9A9",
            keepShow: false,
            opacity: 1,
            hover: false
          },
          //
          hBar: {
            background: "#A9A9A9",
            keepShow: false,
            opacity: 1,
            hover: false
          }
        }
      },
      isSearchMore: false,
      orderIds: "",
      queryForm: {
        warehouseIds: [],
        orderIds: [],
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0,
        timeType: "charge",
        settlementStatus: [],
        paymentStatus: [],
        supplierId: "",
        customerType:''
      },
      customerTypeList:[],
      //表单数据
      tableData: [],
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},
      warehouses: [],
      warehouseMap: {},
      chargeType: [],
      chargeTypeMap: {},
      suppliers: [],
      supplierMap: {},
      currencies: [
        { name: "美元", value: "USD" },
        { name: "欧元", value: "EUR" },
        { name: "人民币", value: "CNY" },
        { name: "港币", value: "HKD" },
        { name: "日元", value: "JPY" }
      ],
      chargeVisible: false,
      //
      addChargeForm: {
        customerName: "",
        orderId: "",
        chargeType: "",
        currency: "",
        amount: 0,
        remarks: ""
      },
      dialogShowVariables: false,
      formulaStr: "",
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1, //当前页
      timeTypes: [
        { id: "charge", name: "扣费时间" },
        { id: "deliver", name: "发货时间" }
      ],
      settlementStatus: [
        { id: "no_settlement", name: "未收款" },
        { id: "partial_settlement", name: "部分收款" },
        { id: "has_settlement", name: "已收款" }
      ],
      paymentStatus: [
        { id: "no_settlement", name: "未付款" },
        { id: "partial_settlement", name: "部分付款" },
        { id: "has_settlement", name: "已付款" }
      ],
      fileList: [],
      dialogVisible2: false,
      dialogVisible3: false,
      costImportMsg: "",
      costFile: "",
      isCancel: false
    };
  },
  filters: {
    formatTime(val) {
      if (val != "") {
        return (
          new Date(val).getFullYear() +
          "-" +
          ("0" + (new Date(val).getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + new Date(val).getDate()).slice(-2) +
          " " +
          ("0" + new Date(val).getHours()).slice(-2) +
          ":" +
          ("0" + new Date(val).getMinutes()).slice(-2) +
          ":" +
          ("0" + new Date(val).getSeconds()).slice(-2)
        );
      }
    }
  },
  created() {
    setTimeout(() => {
      this.initData();
      this.getChargeType();
      this.getCustomerType()
    }, 1000);
  },
  methods: {
    judge(data) {
      if (data) {
        return data.replace(/,/g, "<br>");
      }
    },
    showAllBasicVariables(vars) {
      this.dialogShowVariables = true;
      this.formulaStr = vars.replace(/\n/g, "<br>");
    },
    initData() {
      let _this = this;
      let urlArray = [
        this.findAllCustomerName(),
        this.findAllWarehouse(),
        this.findAllChannle()
      ]; // unknown # of urls (1 or more)

      this.$axios.all(urlArray).then(
        this.$axios.spread(function(customerData, warehouseData, channelData) {
          _this.initCustomerData(customerData);
          _this.initWarehouseData(warehouseData);
          _this.initChannelData(channelData);
          // _this.query();
        })
      );

      this.querySupplier();
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
      _this.warehouses.forEach(a => {
        _this.warehouseMap[a.id] = a.name;
      });
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
        {
          withCredentials: true
        }
      );
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all',
        {
          withCredentials: true
        }
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll',
        {
          withCredentials: true
        }
      );
    },
    //获取费用类型
    getChargeType() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/order/charge-type',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          this.chargeType = data;
          data.forEach((d, i) => {
            this.chargeTypeMap[d.code] = d.name;
          });
        })
        .catch(error => {
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    reset() {
      this.orderIds = "";
      this.queryForm = {
        warehouseIds: [],
        orderIds: [],
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0,
        timeType: "charge",
        settlementStatus: [],
        paymentStatus: [],
        supplierId: ""
      };
      // this.searchTask();
      this.tableData = [];
      this.total = 0;
      this.currentPage = 1;
      this.pageSize = 10;
    },
    searchTask() {
      if (
        this.queryForm.warehouseIds.length > 0 ||
        this.orderIds.length > 0 ||
        this.queryForm.customerIds.length > 0 ||
        this.queryForm.productIds.length > 0 ||
        this.queryForm.startDate.length > 0 ||
        this.queryForm.endDate.length > 0 ||
        this.queryForm.settlementStatus.length > 0 ||
        this.queryForm.paymentStatus.length > 0 ||
        this.queryForm.supplierId.length > 0
      ) {
        this.currentPage = 1;
        this.query();
      } else {
        this.tableData = [];
        this.total = 0;
        this.currentPage = 1;
        this.pageSize = 10;
        this.$message({
          message: "请选择搜索条件",
          type: "warning"
        });
        return;
      }
    },
    exportOrderCost() {
      let _this = this;
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }
      //过滤仓库
      let wlist = [];
      if (this.warehouses != null && this.warehouses.length > 0) {
        if (
          _this.queryForm.warehouseIds &&
          _this.queryForm.warehouseIds.length > 0
        ) {
          wlist = _this.queryForm.warehouseIds;
        } else {
          wlist = this.warehouses.map(a => a.id);
        }
      } else {
        wlist.push("NOT MATCHING");
      }

      let form = JSON.parse(JSON.stringify(_this.queryForm));
      form.warehouseIds = wlist;

      this.$request1({
          url: '/order/exportCharge',
          method: 'post',
          data: form
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `order_charge_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据:'+ res.data.message);
          }          
        })


      // var html = "";
      // for (var a in form) {
      //   if ((a == "startDate" || a == "endDate") && form[a] == null) {
      //     //不要把时间空值放到form中
      //     form[a] = "";
      //   }
      //   html +=
      //     '<input type="hidden" name="' + a + '" value="' + form[a] + '" />';
      // }
      // html += '<input type="hidden" name="currentPage" value="1" />';
      // html += '<input type="hidden" name="pageSize" value="1" />';
      // var sfForm = document.getElementById("theform");
      // sfForm.innerHTML = html;
      // sfForm.action = '/order/exportCharge';
      // sfForm.submit();


    },
    query() {
      let _this = this;
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }

      //过滤仓库
      let wlist = [];
      if (this.warehouses != null && this.warehouses.length > 0) {
        if (
          _this.queryForm.warehouseIds &&
          _this.queryForm.warehouseIds.length > 0
        ) {
          wlist = _this.queryForm.warehouseIds;
        } else {
          wlist = this.warehouses.map(a => a.id);
        }
      } else {
        wlist.push("NOT MATCHING");
      }

      this.$request1({
        method: 'post',
        url: '/order/charge/query',
        withCredentials: true,
        data: {
          orderIds: this.queryForm.orderIds,
          refNumbers: this.queryForm.refNumbers,
          customerIds: this.queryForm.customerIds,
          productIds: this.queryForm.productIds,
          startDate: this.queryForm.startDate,
          endDate: this.queryForm.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          export: this.queryForm.export,
          timeType: this.queryForm.timeType,
          warehouseIds: wlist,
          settlementStatus: this.queryForm.settlementStatus,
          paymentStatus: this.queryForm.paymentStatus,
          supplierId: this.queryForm.supplierId
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            let taskData = data.data;
            _this.total = data.total;
            if (_this.total > 0) {
              _this.tableData = taskData;
            } else {
              _this.tableData = [];
              _sthis.total = 0;
            }
          } else {
            _this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    //  添加费用
    addOrderCharge(row) {
      this.addChargeForm.orderId = row.orderId;
      this.addChargeForm.customerName = this.customerMaps[row.orgOwner];
      this.addChargeForm.amount = 0.0;
      this.addChargeForm.remarks = "";
      this.chargeVisible = true;
    },
    // 确定添加费用
    addChargeDone() {
      if (this.addChargeForm.chargeType == "") {
        this.$message.error("请选择费用类型");
        return;
      }
      if (this.addChargeForm.currency == "") {
        this.$message.error("请选择币种");
        return;
      }
      if (this.addChargeForm.amount == 0) {
        this.$message.error("请输入费用金额");
        return;
      }
      // return;
      this.$request1({
        method: 'POST',
        url: '/order/charge',
        data: this.addChargeForm,
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.query();
            this.chargeVisible = false;
          } else {
            this.$message.error("操作失败：" + data.message);
          }
        })
        .catch(error => {
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    downloadBill() {
      let _this = this;
      let startDate = this.queryForm.startDate;
      let endDate = this.queryForm.endDate;

      if (startDate.length == 0 && endDate.length == 0) {
        startDate = this.getStartTime();
        endDate = this.getEndTime();
      }

      //过滤仓库
      let wlist = [];
      if (this.warehouses != null && this.warehouses.length > 0) {
        if (
          _this.queryForm.warehouseIds &&
          _this.queryForm.warehouseIds.length > 0
        ) {
          wlist = _this.queryForm.warehouseIds;
        } else {
          wlist = this.warehouses.map(a => a.id);
        }
      } else {
        wlist.push("NOT MATCHING");
      }

      this.$windowOpen1(
        '/order/charge/download-bill' +
          "?orderId=" +
          this.queryForm.orderIds.toString() +
          "&customerId=" +
          this.queryForm.customerIds.toString() +
          "&productId=" +
          this.queryForm.productIds.toString() +
          "&warehouseIds=" +
          wlist.toString() +
          "&startDate=" +
          this.queryForm.startDate +
          "&endDate=" +
          this.queryForm.endDate +
          "&timeType=" +
          this.queryForm.timeType +
          "&settlementStatus=" +
          this.queryForm.settlementStatus +
          "&paymentStatus=" +
          this.queryForm.paymentStatus
      );
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },
    getStartTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = (Array(2).join(0) + (date.getMonth() + 1)).slice(-2);
      let day = (Array(2).join(0) + date.getDate()).slice(-2);
      month = parseInt(month) - 1;
      if (month == 0) {
        year = parseInt(year) - 1;
        month = 12;
      }
      let days = new Date(year, month, 0);
      if (day > days.getDate()) {
        day = days.getDate();
      }
      return year + "-" + month + "-" + day;
    },
    getEndTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = (Array(2).join(0) + (date.getMonth() + 1)).slice(-2);
      let day = (Array(2).join(0) + date.getDate()).slice(-2);
      return year + "-" + month + "-" + day;
    },
    // 供应商名称
    querySupplier() {
      this.$request1({
        method: 'GET',
        url: '/supplier'
      })
        .then(response => {
          this.suppliers = response.data;
          if (this.suppliers != null && this.suppliers.length > 0) {
            this.suppliers.forEach(item => {
              this.supplierMap[item.id] = item.name;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handlePictureCardChange(file, fileList) {
      this.fileList.push(file);
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    costImport() {
      this.fileList = [];
      this.dialogVisible2 = true;
    },
    costChargeImport(continueUpload) {
      if (this.fileList.length == 0) {
        this.$message.error("请选择导入文件");
        return;
      }

      var formData = new FormData();
      if (this.fileList.length > 0) {
        formData.append("file", this.fileList[0].raw);
      }
      formData.append("continueUpload", continueUpload);

      const instance = this.$request1.create({
        withCredentials: true,
        timeout: 300000
      });

      let loadingInstance;
      instance.interceptors.request.use(
        config => {
          loadingInstance = Loading.service({
            text: "正在提交。。。。数据量太大时间会比较久，请不要重复提交。",
            lock: true,
            fullscreen: true,
            background: "rgba(0, 0, 0, 0.8)",
            spinner: "el-icon-loading"
          });
          return config;
        },
        error => {
          loadingInstance.close();
          if (error.response && error.response.status == 401) {
            // todo-login
            // var r = '/login';
            // window.location.href = r;
          }
          return Promise.reject(error);
        }
      );
      instance.interceptors.response.use(
        function(response) {
          loadingInstance.close();
          return response;
        },
        function(error) {
          loadingInstance.close();
          this.fileList = [];
          if (error.response && error.response.status == 401) {
            // todo-login
            // var r = '/login';
            // window.location.href = r;
          }
          return Promise.reject(error);
        }
      );

      instance({
        method: 'POST',
        url: '/order/charge/costImport',
        data: formData,
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(res => {
          if (res.data.success) {
            this.dialogVisible2 = false;
            if (!continueUpload) {
              try {
                this.$emit("closeTransferPanel");
              } catch (err) {
                console.error(err);
              }

              this.costImportMsg = "请核对补录成本差额";
              if (res.data.message == "error") {
                this.costImportMsg = "存在异常，请下载文件查看";
                this.isCancel = true;
              } else {
                this.isCancel = false;
              }

              this.costFile = res.data.data;
              this.dialogVisible3 = true;
            } else {
              this.$message.success("提交成功");
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    continueUpload() {
      if (!this.isCancel) {
        this.costChargeImport(true);
        setTimeout(() => {
          this.query();
        }, 500);
      }
      this.fileList = [];
      this.dialogVisible3 = false;
    },
    download() {
      var byteCharacters = atob(this.costFile);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      let blob = new Blob([byteArray], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      let objectUrl = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = objectUrl;
      a.download = "costImport_return.xlsx";
      a.click();

      if (this.isCancel) {
        this.dialogVisible3 = false;
      }
    },
    // 客户类型字典 
      getCustomerType() {
      this.$request1.get(
        '/customer/queryCustomerType'
      ).then(res => {
        if(res.data && res.data.length > 0) {
          this.customerTypeList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.el-table .cell {
  .trace-item {
    height: 34px;
    line-height: 34px;
    margin: 0 -10px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #ebeef5;
  }
  > .trace-item:first-child {
    margin-top: -10px;
  }
  > .trace-item:last-child {
    border-bottom: none;
    margin-bottom: -10px;
  }
}
.item {
  width: 800px;
}

.el-card .el-card__header .el-form.header-search__form .search-form__buttons {
  padding-left: 110px;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/ordercharge.vue